import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { mangaSeries } from "@/mocks/manga";

const steps = [
  {
    icon: "ri-user-add-line",
    title: "加入书架",
    desc: "把常看的漫画加入追更书架，集中管理所有连载。",
  },
  {
    icon: "ri-flashlight-line",
    title: "查看动态",
    desc: "每天看一眼更新动态，最新话、补更、断更一目了然。",
  },
  {
    icon: "ri-check-double-line",
    title: "同步进度",
    desc: "详情页记录阅读进度，一键查看看到第几话。",
  },
];

export default function UpdateStatus() {
  const backfill = mangaSeries.find((m) => m.isBackfill);
  const hiatus = mangaSeries.find((m) => m.isOnHiatus);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="追更进度"
        title="补更、断更动态，轻松掌握"
        desc="再也不用天天刷好几遍，66漫画网帮你盯紧每部漫画的补更与断更状态。"
      />

      <div className="grid gap-5 lg:grid-cols-3">
        <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
          <h3 className="font-display text-lg text-foreground-900">三步轻松追更</h3>
          <div className="mt-5 flex flex-col gap-4">
            {steps.map((s, i) => (
              <div key={s.title} className="flex gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className={`${s.icon} text-lg`}></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-900">
                    {i + 1}. {s.title}
                  </p>
                  <p className="mt-1 text-sm text-foreground-600">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <Link
            to="/series"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            前往追更书架
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {backfill && (
          <div className="flex flex-col overflow-hidden rounded-2xl border border-accent-300 bg-accent-50">
            <div className="flex items-center gap-2 px-6 pt-5">
              <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                今日补更
              </span>
              <span className="text-xs text-accent-800">恢复更新 · 一口气补齐</span>
            </div>
            <Link to={`/series/${backfill.id}`} className="group flex flex-1 items-center gap-4 p-6">
              <img
                src={backfill.cover}
                alt={`${backfill.title} 补更动态`}
                className="h-40 w-28 shrink-0 rounded-lg object-cover object-top"
              />
              <div className="min-w-0">
                <h3 className="font-display text-xl text-foreground-900 group-hover:text-accent-700">
                  {backfill.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-600">{backfill.author}</p>
                <p className="mt-2 truncate text-sm text-accent-700">{backfill.lastChapter}</p>
                <p className="mt-1 text-xs text-foreground-500">更新于 {backfill.updateDate}</p>
              </div>
            </Link>
          </div>
        )}

        {hiatus && (
          <div className="flex flex-col overflow-hidden rounded-2xl border border-background-300 bg-background-100">
            <div className="flex items-center gap-2 px-6 pt-5">
              <span className="rounded-full bg-background-300 px-3 py-1 text-xs font-medium text-foreground-700">
                近期断更
              </span>
              <span className="text-xs text-foreground-600">暂未恢复 · 持续跟进</span>
            </div>
            <Link to={`/series/${hiatus.id}`} className="group flex flex-1 items-center gap-4 p-6">
              <img
                src={hiatus.cover}
                alt={`${hiatus.title} 断更状态`}
                className="h-40 w-28 shrink-0 rounded-lg object-cover object-top"
              />
              <div className="min-w-0">
                <h3 className="font-display text-xl text-foreground-900 group-hover:text-primary-600">
                  {hiatus.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-600">{hiatus.author}</p>
                <p className="mt-2 truncate text-sm text-foreground-700">{hiatus.lastChapter}</p>
                <p className="mt-1 text-xs text-foreground-500">更新于 {hiatus.updateDate}</p>
              </div>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}